<template>
  <div id="app">
    <notifications group="foo"/>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
